import { withOAuth } from "aws-amplify-react";
import {Auth} from "aws-amplify"
import React from "react";
import { setLocalStorage } from "../../utils/LocalStorage";
import Button from "../common/Button";

const ButtonOAuth = (props) => {
  Auth.currentAuthenticatedUser()
    .then((session) => {
      if (Object.entries(session).length > 0) {
        props.history.push("/home");
      }
    })
    .catch((err) => {
      console.error(err);
    });
  async function handleClickAuth() {
    const customProvider = process.env.REACT_APP_OAUTH_PROVIDER;
    console.log(
      "🚀 ~ file: index.jsx ~ line 19 ~ handleClickAuth ~ customProvider",
      customProvider
    );
    try {
      // setLocalStorage("loginFederate", "true");
      let responseFederate = await Auth.federatedSignIn({
        provider: customProvider,
      });
      console.log(
        "🚀 ~ file: index.jsx ~ line 24 ~ handleClickAuth ~ responseFederate",
        responseFederate
      );
      // const responseAuth = await Auth.currentAuthenticatedUser();
      // setLocalStorage("responseAuth", responseAuth);
    } catch (error) {
      console.error("Ocurrio un error con el login", error);
    }
  }

  // const loginFederate = async (e) => {
  //   try {
  //     console.log("loginFederate");
  //     setLocalStorage("loginFederate", "true");
  //     const customProvider = process.env.REACT_APP_OAUTH_PROVIDER;
  //     var auth = await props.OAuthSignIn(e, customProvider);
  //     console.log("file botton ~ line 13 : " + auth);
  //     props.push("/login-federado");
  //   } catch (e) {
  //     console.log("loginFederate error>>> ", e);
  //   }
  // };

  return (
    // <Button primary onClick={(e) => handleClickAuth()}>
    <Button primary onClick={handleClickAuth}>
      USUARIO RIMAC
    </Button>
  );
};
export default ButtonOAuth;
// export default ButtonOAuth;
